import dayjs from 'dayjs'
import $ from 'jquery'
import { qcopy } from '@u'

// const error = console.error
const error = function noop() {}

function _getStartAndEndDateTimestamp(date) {
  const startOfDate = +dayjs(date)
  const endOfDate = dayjs(date).add(1, 'day') - 1
  return { startOfDate, endOfDate }
}

function _trueBasalsOfDateFilterFactory(extra = {}) { // 当天，并且不是服务端插入的点
  const { startOfDate, endOfDate } = extra
  if (!startOfDate || !endOfDate) {
    error(`[_trueBasalsOfDateFilterFactory]入参错误，没有传startOfDate或endOfDate, extra: `, extra)
    return (arr) => true // 全部保留
  }
  return (arr) => {
    let isInDate = false
    let isNotAppendedByServer = false
    if (Array.isArray(arr) && arr.length) {
      const t = arr[0]
      const v = arr[1]
      const isAppendedByServer = arr[2]
      const tn = dayjs(t)
      isNotAppendedByServer = !isAppendedByServer
      isInDate = tn - startOfDate >= 0 && tn - endOfDate <= 0      
    }
    return isInDate && isNotAppendedByServer      
  }
}

function _needAppendOneBasalPointToEndOfRange(date, _basals = [], deadlineGaps = [], dateStartNeedAppend = false, yesterdayBasals = [], lastUploadTime) { // 是否需要再date后面插入一个23:59:59的基础率点
  const { startOfDate, endOfDate } = _getStartAndEndDateTimestamp(date)
  const basals = _basals.filter(_trueBasalsOfDateFilterFactory({ startOfDate, endOfDate }))
  const fmt = 'YYYY-MM-DD'
  let shouldAppend = true
  const nowT = dayjs()
  const $date = dayjs(date)
  let lastUploadTimeIsDate = false // 是指整个报告生成期间最后一次上传事件是否是在date这天(包含前后一天)
  let lastUploadTimeIsBeforeDate = false // 是指整个报告生成期间最后一次上传事件是否是在date这天之前
  if (lastUploadTime) {
    const $lastUpload = dayjs(lastUploadTime)
    if ($lastUpload - $date.startOf('day') < 0) {
      lastUploadTimeIsBeforeDate = true
    }
    
    if ($lastUpload.format(fmt) === $date.format(fmt)) {
      lastUploadTimeIsDate = true
    }
  }
  
  do {
    if (Array.isArray(basals)) {
      const dateEmpty = !basals.length
      if (dateEmpty && !dateStartNeedAppend) { // date天没有basal数据，并且date一开始也不需要加'点'(即可能前一天泵停了)
        // 空的basals
        shouldAppend = false
        break
      }

      const last = (dateStartNeedAppend && dateEmpty) ? yesterdayBasals[yesterdayBasals.length - 1] : basals[basals.length - 1] // 因为泵体本身会在00:00时候产生一条数据，所以就算时区视窗偏移了，那么只要泵体在运行，yesterday至少有一条record(也即有了basal记录)
      let lastT
      let endT

      if (lastUploadTimeIsDate) { // 最后一次上传数据是date这天
        endT = lastUploadTime
      } else {
        if (lastUploadTimeIsBeforeDate) { // 最后一次数据上传是date之前，所以date其实是没有数据的(即不要绘画)
          // 那么直接false
          shouldAppend = false
          break
        } else { // 最后一次数据上传是date之后
          endT = endOfDate
        }
      }
      
      if (last) {
        if (last.length) {
          lastT = last[0]          
        }
      }
      
      if (!lastT) {
        lastT = endT
      }      
      const gap = [lastT, endT]
      
      const notDeadInGap = deadlineGaps.every(r => {
        let deadInGap = false
        if (r && r[0]) {
          const deadST = r[0]
          const deadET = r[1]
          deadInGap = !(deadET - gap[0] < 0 || deadST - gap[1] > 0)
        }
        return !deadInGap
      })
      if (!notDeadInGap) {
        // 在这个gap中，有dead，也即不持续到endT
        shouldAppend = false
        break
      }
    } else {
      shouldAppend = false
      break      
    }    
    /* eslint-disable-next-line*/
  } while(false)

  return shouldAppend
}

function _needAppendOneBasalPointToStartOfRange(date, _basals = [], deadlineGaps = [], yesterdayNotDeadToTheEnd = true, lastUploadTime) { // 是否需要再date最前面插入一个00:00:00的基础率点
  const { startOfDate, endOfDate } = _getStartAndEndDateTimestamp(date)
  const basals = _basals.filter(_trueBasalsOfDateFilterFactory({ startOfDate, endOfDate }))
  let shouldAppend = true
  const nowT = dayjs()
  const $date = dayjs(date)
  const fmt = 'YYYY-MM-DD'
  let lastUploadTimeIsBeforeDate = false // 是指整个报告生成期间最后一次上传事件是否是在date这天之前
  if (lastUploadTime) {
    const $lastUpload = dayjs(lastUploadTime)
    if ($lastUpload - $date.startOf('day') < 0) {
      lastUploadTimeIsBeforeDate = true
    }
  }

  do {
    if (!yesterdayNotDeadToTheEnd) { // 前一天，没有插入23:59:59(即一直死过了23:59:59死到今天)
      shouldAppend = false
      break
    }
    
    if (Array.isArray(basals)) {
      // if (!basals.length) { // 因为可能今天basals是空的，但是yesterday有持续过来的数据
      //   // 空的basals
      //   shouldAppend = false
      //   break
      // }      
      const dateEmpty = !basals.length

      if (lastUploadTimeIsBeforeDate) {
        // 今天还没有数据上传过,所以也就没必要插数据(因为今天肯定没有数据)
        // 那么直接false
        shouldAppend = false
        break
      }
      
      const first = basals[0] || {}
      const firstT = first[0]

      const gap = (dateEmpty && yesterdayNotDeadToTheEnd) ? [startOfDate, startOfDate] : [startOfDate, firstT] // 临界: 死线触发的事件的时间戳正好在startOfDate
      const notDeadInGap = deadlineGaps.every(r => {
        let deadInGap = false
        if (r && r[0]) {
          const deadST = r[0]
          const deadET = r[1]
          deadInGap = !(deadET - gap[0] < 0 || deadST - gap[1] > 0)
        }
        return !deadInGap
      })
      if (!notDeadInGap) {
        // 在这个gap中，有dead，也即不持续到23:59:59
        shouldAppend = false
        break
      }
    } else {
      shouldAppend = false
      break      
    }    
    /* eslint-disable-next-line*/
  } while(false)

  return shouldAppend
}

export function _legalDataReadingsInTargetChart(readingsInTargetChart = {}) {
  const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
  const rst = veryLow && veryhigh && high && low && target
  return rst
}

/* 泵、血糖，判断是否是'有信息'的dailyList的一项数据结构 */
function _notEmptyArray(t = []) {
  return Array.isArray(t) && t.length > 0
}

function _notZero(v = '') {
  return +v !== 0
}

function _hasDataObj(obj, _hasDataHelperNeedCheckKeys = []) {
  // console.error(`_hasDataObj obj, _hasDataHelperNeedCheckKeys: ${_hasDataHelperNeedCheckKeys}`, obj)
  if (_hasDataObj._counter === undefined) {
    _hasDataObj._counter = 1
  } else {
    _hasDataObj._counter++
  }
  
  if (_hasDataObj._counter > 5) {
    console.error(`_hasDataObj 为了避免死循环，直接return false`)
    return false
  }
  
  const arr = Object.keys(obj)
  let hasData = false
  // console.error(`arr: ${arr}`)
  // console.error(`_hasDataHelperNeedCheckKeys`, _hasDataHelperNeedCheckKeys)
  for (const k of arr) {
    if (!_hasDataHelperNeedCheckKeys || !_hasDataHelperNeedCheckKeys.length) {
      console.warn(`_hasDataObj的入参keys的数组为空，这意味着，这个函数的返回值一直会是false`)
    }
    if (!_hasDataHelperNeedCheckKeys.includes(`${k}`.trim())) {
      // derror(`k: ${k},这个字段直接跳过`)
      // key值不在我们判断是否有数据的选项里头，直接return false
      continue
    }
    
    const v = obj[k]
    if (typeof v === 'object') {
      if (Array.isArray(v)) {
        hasData = _notEmptyArray(v)
      } else {
        // if (`${k}` === 'insulinChart') {
        //   console.error(`v, `, v)
        //   window.vv = v
        // }
        hasData = _hasDataObj(v, _hasDataHelperNeedCheckKeys)
        // hasData = _hasDataObj(v)
      }
    } else {
      hasData = _notZero(v)
    }
    if (hasData) {
      break
    }
  }

  // reset
  _hasDataObj._counter = 0
  return hasData
}

// carbsRecord是显示CO和Carbs的地方；dietRecord其实是事件(event)
const _hasDataHelperNeedCheckKeys = ['readingsInTargetChart', 'insulinChart', 'BgEventArray', 'bloodGlucoseRecord', 'exerciseRecord', 'dietRecord', 'carbsRecord', 'insulinRecord', 'medicationRecord', 'threeChartData'].concat(['veryLow', 'veryHigh', 'veryhigh', 'high', 'low', 'target', 'value', 'percent']).concat(['bgMean', 'bgTotal', 'bgPerDay', 'carbohydrMean', 'bolusPerDay', 'cgmMean', 'bolusTotalCount']).concat(['highArray', 'lowArray']).concat(['totalBasal', 'totalBolus', 'list', 'basalPercent', 'bolusPercent']).concat(['dataUploadHis', 'uploadTimeStr']) // 这里把所有key值全枚举出来的原因是，有时候接口返回的数据里头，会有别的字段(譬如 lpp)下也是有数据的。这种时候，我也会认为此页面有数据，从而会去渲染；然而实际上，这种情况应该认为没有数据，不渲染（lpp字段应该不去看）
export function _legalDataDailyListOneDataDoNotUsedInComputed(v, i) { // 血糖报告需要的daily的数据结构
  // 未知原因，导致此函数再computed里头使用的时候，会无限触发computed,从而死循环。可能是_hasDataObj在递归的时候某个地方更改了数据?
  // derror(`_legalDataDailyListOneData`)
  if (!v) return false
  const rst = _hasDataObj(v, _hasDataHelperNeedCheckKeys)
  // derror(`_legalDataDailyListOneData, rst: ${rst}`)
  
  return rst 
}

export function _legalDataDailyListOneDataWithPumpInfoDoNotUsedInComputed(v, i) { // 泵报告需要的daily的数据结构(包含了_legalDataDailyListOneDataDoNotUsedInComputed的逻辑)
  // 未知原因，导致此函数再computed里头使用的时候，会无限触发computed,从而死循环。可能是_hasDataObj在递归的时候某个地方更改了数据?
  const bgReportKeys = _hasDataHelperNeedCheckKeys
  const _needCheckKeys = [...bgReportKeys, ...['cgmRecordList', 'eventData', 'deviceTimeStr'], ...['insulinChart', 'list', 'basalPercent', 'bolusPercent', 'totalBolus', 'totalBasal']] // 因为这里的concat或者_hasDataObj里头的数组相关的函数，会导致在computed里头使用时候，无限触发这个computed，从而死循环
  // console.error(`_needCheckKeys`, _needCheckKeys)
  if (!v) return false
  const rst = _hasDataObj(v, _needCheckKeys)
  // console.error(`_legalDataDailyListOneDataPumpInfo, rst: ${rst}`)
  
  return rst 
}

/* End 泵、血糖，判断是否是'有信息'的dailyList的一项数据结构 */

export function _getPumpBasalFromRecords(records = [], date) {
  const rst = []
  // const $start = date ? dayjs(date) : dayjs().startOf('day')
  const noBasalData = records.every(record => record && +record.basalRate === 0)
  if (noBasalData) return rst

  records.forEach(record => {
    if (record) {
      // if (record.basalRate > 0) {
      const isAppendedByServer = record && [null, undefined, '', 'null', 'Null'].includes(record.index)
      const index = record.index || record.eventIndex
      const historyId = record.historyId
      rst.push([
        +dayjs(record.dateTimeStr),
        record.basalRate,        
        isAppendedByServer,
        index,
        historyId
      ]) 
      // }
    } else {
      console.error(`_getPumpBasalFromRecords, 非法的record: ${record}`, record)
    }
  })

  rst.sort((first, second) => {
    let gap = first[0] - second[0] // 升序，record.dateTimeStr小的在数组前面;从而会first[0]-second[0] > 0

    if (gap === 0) {
      // 当两个时间戳一样的时候
      const findex = first[3]
      const sindex = second[3]
      const indexHasLooped = Math.abs(findex - sindex) > 10// index循环套圈了
      gap = findex - sindex // 升序，index越小的排在前面
      if (indexHasLooped) {
        if (gap < 0) {
          gap = 1 // first应该排到后面去;例如sindex: 2000, findex: 0; findex套圈了
        } else if (gap > 0) {
          gap = -1 // first应该排到前面去;例如sindex: 0, findex: 2000; 
        }
      }
    }
    
    return gap
  })

  return rst
}
export function _appendTwoPointsToBasals(date, _basals = [], deadlineGaps = [], yesterday, lastUploadTime) { // 返回的基础率，要考虑插入两个点。1，23:59:59插入一个;2,00:00:01插入一个
  const { startOfDate, endOfDate } = _getStartAndEndDateTimestamp(date)
  const basals = _basals.filter(_trueBasalsOfDateFilterFactory({ startOfDate, endOfDate }))
  let yesterdayBasalsWithoutTwoPoints = []

  // if (lastUploadTime) {
  //   const tmp = dayjs(lastUploadTime).format('YYYY-MM-DD HH:ss')
  //   console.error(tmp)
  //   debugger
  // }
  
  do {
    if (yesterday) {
      const {
        threeChartData
      } = yesterday
      if (threeChartData) {
        const { insulinChart } = threeChartData
        if (insulinChart) {
          const list = insulinChart.list || []
          yesterdayBasalsWithoutTwoPoints = _getPumpBasalFromRecords(list)
        }
      }
    }
    /* eslint-disable-next-line*/
  } while(false)
  
  let startPoint
  let endPoint
  
  do {
    // step1, 判断前一天是否需要再23:59:59插入一个点(即，一直正常运行到23:59:59，期间没有dead)
    const oneDayBefore = dayjs(date).subtract(1, 'day').format('YYYY-MM-DD')
    const yesterNeedEnd = _needAppendOneBasalPointToEndOfRange(oneDayBefore, yesterdayBasalsWithoutTwoPoints, deadlineGaps, false, [], lastUploadTime)
    // step2, 判断当前date是否需要在00:00:00插入一个点
    const dateNeedStart = _needAppendOneBasalPointToStartOfRange(date, basals, deadlineGaps, yesterNeedEnd, lastUploadTime)
    // step3, 判断当前date是否需要再23:59:59(或dayjs()——当前时刻)插入一个点(即，一直正常运行到23:59:59(或dayjs()——当前时刻)，期间没有dead)
    const dateNeedEnd = _needAppendOneBasalPointToEndOfRange(date, basals, deadlineGaps, dateNeedStart, yesterdayBasalsWithoutTwoPoints, lastUploadTime)
    // const nowT = dayjs()
    // const { endOfDate } = _getStartAndEndDateTimestamp(date)
    // const endTilNow = endOfDate - nowT >= 0 // date是今天，并且还没到23:59:59

    const dateEmpty = basals && !basals.length
    if (dateNeedStart) {
      const yesterdayLast = yesterdayBasalsWithoutTwoPoints[yesterdayBasalsWithoutTwoPoints.length - 1] || []
      const yesterdayLastV = yesterdayLast[1]
      if (yesterdayLastV !== undefined) {
        startPoint = [startOfDate, yesterdayLastV, true]
      } else {
        error(`尝试插入${date}开始的基础率点时出问题，这是因为yesterday的最后基础率我无法获得, yesterdayLast:`, yesterdayLast)
      }
    }
    if (dateNeedEnd) {
      const fmt = 'YYYY-MM-DD'
      const nowT = dayjs()
      
      const yesterdayLast = yesterdayBasalsWithoutTwoPoints[yesterdayBasalsWithoutTwoPoints.length - 1] || []
      const yesterdayLastV = yesterdayLast[1]

      const dateLast = (dateNeedStart && dateEmpty) ? yesterdayLast : (basals[basals.length - 1] || [])
      const lastV = dateLast[1]
      let lastUploadTimeIsDate = false // 是指整个报告生成期间最后一次上传事件是否是在date这天(包含前后一天)
      let lastUploadTimeIsBeforeDate = false // 是指整个报告生成期间最后一次上传事件是否是在date这天之前
      if (lastUploadTime) {
        const $date = dayjs(date)
        const $lastUpload = dayjs(lastUploadTime)
        if ($lastUpload - $date.startOf('day') < 0) {
          lastUploadTimeIsBeforeDate = true
        }
        
        if ($lastUpload.format(fmt) === $date.format(fmt)) {
          lastUploadTimeIsDate = true
        }
      }
      
      // if (`${date}` === '2023-05-31' && lastUploadTime) {
      //   debugger
      // }
      if (lastV !== undefined) {
        // endPoint = endTilNow ? [nowT, lastV] : [endOfDate, lastV]
        if (lastUploadTimeIsDate) { // 最后一次上传数据是date这天
          endPoint = [+lastUploadTime, lastV, true]
        } else {
          if (lastUploadTimeIsBeforeDate) { // 最后一次数据上传是date之前，所以date其实是没有数据的(即不要绘画)
            console.error(`[逻辑黑洞]dateNeedEnd应该判断出来是false，但却是计算出来的值是true. date: ${date}, lastUploadTime: ${dayjs(lastUploadTime).format('YYYY-MM-DD HH:mm')}`)
            // 那么直接跳出逻辑
            break
          } else { // 最后一次数据上传是date之后
            endPoint = [endOfDate, lastV, true]
          }
        }
      } else {
        if (dateNeedStart && dateEmpty) { // 昨天里头数据也没找到
          error(`尝试插入${date}结束的基础率点时出问题，这是因为${date}的最后基础率我无法获得,并且昨天的最后基础率我也无法获得, dateLast:`, dateLast)
        } else {
          error(`尝试插入${date}结束的基础率点时出问题，这是因为${date}的最后基础率我无法获得, dateLast:`, dateLast)          
        }
      }
    }
    /* eslint-disable-next-line*/
  } while(false)
  
  return [startPoint, ...basals, endPoint].filter(r => r)
}

export function _getPumpBasalShouldShowLabelRecordsFromBasals(rst = []) {
  // step2, 合并掉值相同的项
  const rst2 = []
  const l = rst.length
  for (let i = 0; i < l; i++) {
    const r = rst[i]
    const time = r[0]
    const value = r[1]
    const lastInRst2 = rst2[rst2.length - 1]
    const lastValue = lastInRst2 ? lastInRst2[1] : undefined

    if (lastValue === undefined || (lastValue !== undefined && `${lastValue}` !== `${value}`)) {
      // 推入结果
      rst2.push(r)
    }
  }

  return rst2
}

function _legalBigDosageData(value, record = {}) {
  const legal = value - 0 > 0 && value - 35 < 0
  const { delayTime } = record
  // if (!legal) {
  //   try {
  //     console.error(`返回的大剂量记录数据里头有非法的数据值，过滤掉。这记录大剂量值是${value},不在(0, 35)范围内, record: ${JSON.stringify(record)}`, record)
  //   } catch (error) {
  //     console.error('被捕获:' + error)
  //   }
  // }
  return legal || (+value === 0 && delayTime) // totalBolus可能为0
  // return (+value === 0 && delayTime) // dev, mock, test
}
function _recordIsOriginalFromAjax(record = {}) {
  const recordIsOriginalFromAjax = record && record.dateTimeStr && record.delayTime && record.check_time === undefined && record.data === undefined // record数据源是ajax返回的数据结构
  return recordIsOriginalFromAjax
}

function _getBigDosageData(r = {}, getTrueData = false) {
  const type = _getBigDosageType(r)
  const _isQuick = _isImediateDosage(type)
  const _isExtend = _isExtendDosage(type)
  let data
  
  if (_recordIsOriginalFromAjax(r)) {
    // type只有0,1
    if (_isQuick) {
      data = r.totalBolus
    } else if (_isExtend) {
      const isSplitedExtend = r.extendId
      if (isSplitedExtend) {
        if (getTrueData) {
          // 真实的这个延长量的值
          data = r.totalBolus
        } else {
          data = r.totalExtendBolus
        }
      } else {
        // 单个延长量没有被分割成多个
        data = r.totalBolus
      }
    } else {
      data = r.totalBolus
    }
  } else {
    // record数据结构已经被我们处理过了
    // 会有type === 2的双波数据
    // if (!getTrueData && !window.deb) {
    //   window.deb = true
    //   debugger
    // }
    // if (!getTrueData && +r['index'] === 875) {
    //   debugger
    // }
    const _isDual = _isDualDosage(type)
    const _belongToDual = r.groupId
    if (_isDual) {
      console.error(`[双波大剂量,获取data的逻辑目前有问题的，tbc, 需要改], record:`, r)
      if (getTrueData) {
        data = r.data
      } else {
        data = r.dualTotalBolus
      }
    } else { // 不是type===2的双波大剂量记录
      if (_isExtend) {
        const isSplitedExtend = !r.groupId && r.extendId
        if (isSplitedExtend) {
          if (getTrueData) {
            // 真实的这个延长量的值
            data = r.data
          } else {
            // 不真实的这个延长量的值。即这个被分成多个数据记录的同一个延长量，第一条的记录会返回totalExtendBolus，其它的都返回0
            if (r.extendIdFirstOne) {
              data = r.totalExtendBolus
            } else {
              data = 0
            }
          }
        } else {
          if (_belongToDual) {
            // 双波一部分
            if (!r.extendId) {
              // 双波中:没有被分割的延长量
              data = r.data
            } else {
              // 双波中:并且是被分割的延长量              
              // if (!getTrueData && +r['index'] === 875) {
              //   debugger
              // }
              if (r.extendIdFirstOne) {
                if (getTrueData) {
                  data = r.data
                } else {
                  data = r.totalExtendBolus                  
                }
              } else {
                if (getTrueData) {
                  data = r.data
                } else {
                  data = r.totalExtendBolus                  
                }
              }
            }
          } else {
            // 单个延长量没有被分割成多个
            data = r.data
          }
        }
      } else {
        // 非type === 1: 立即量
        if (getTrueData) {
          data = r.data
        } else {
          // 不取true data
          if (_belongToDual) {
            // 双波的一部分，这立即量属于双波一部分
            data = r.data
          } else {
            // 这立即量不属于双波一部分
            data = r.data
          }          
        }
      }
    }
  }

  if (data === undefined) {
    console.error(`[逻辑有误]_getBigDosageData返回值为undefined. getTrueData: ${getTrueData}. type: ${type}, _isQuick: ${_isQuick}, _isExtend: ${_isExtend} , 数据结构是否从ajax那边有变化: ${!_recordIsOriginalFromAjax(r)} 的record: `, r)
  }
  return data
}
function _getBigDosageType(r = {}) {
  if (_recordIsOriginalFromAjax(r)) {
    return r.dataType
  } else {
    // record数据结构已经被我们处理过了
    return r.dataType !== undefined ? r.dataType : r.type
  }
}
export const getBigDosageData = _getBigDosageData
export const getBigDosageType = _getBigDosageType
export function _getPumpBigDosageFromRecords(_records = [], minWidthMinutes) {
  // console.error(`_getPumpBigDosageFromRecords, minWidthMinutes: ${minWidthMinutes}`)
  const records = (_records.map(obj => qcopy(obj))).filter(r => {
    let legal = false
    if (r) {
      const type = r.dataType !== undefined ? r.dataType : r.type

      legal = _isImediateDosage(type) || _isExtendDosage(type)
    }
    return legal 
  }) // 副本，不影响原来的list
  const rst = [] // { data, check_time, duration }
  const _alreadyProcessedRecordsI = []
  const multiExtendRecords = {} // 被分割成多段的延长量

  records.forEach((r, i) => {
    if (r) {
      if (_alreadyProcessedRecordsI.includes(i)) {
        if (_legalBigDosageData(+_getBigDosageData(r, true), r)) { // r只会是: 双波，普通延长量等等.即非"不是双波并且是被分割成多个的延长量"
          rst.push({
            ...r,
            index: r.index,
            data: _getBigDosageData(r, true), // "不是双波并且是被分割成多个的延长量",所以第二个参数可传可不传
            check_time: r.check_time, // 这个check_time已被处理过，已偏移过
            true_check_time: r.true_check_time,
            duration: r.delayTime, // 这个delayTime已被处理成新的duration了
            trueDuration: r.trueDuration,
            groupId: r.groupId,
            extendId: r.extendId,
            type: _getBigDosageType(r)
          })
        }
        return // 跳过
      }
      const check_time = r.dateTimeStr
      const _d = r.delayTime
      const duration = minWidthMinutes > 0 ? Math.max(_d, minWidthMinutes * 1000 * 60) : _d // 微秒
      const diff = _d - duration
      const durationExpanded = diff < 0
      const nextR = records[i + 1] || {}
      
      const type = _getBigDosageType(r)

      if (_legalBigDosageData(+_getBigDosageData(r, true), r)) {
        const { extendId, groupId } = r // groupId优先级比extendId高;groupId代表是一个双波，extendId代表一个延长量被分成多段(有可能是单独延长量被分割，也有可能是双波里头的延长量被分割)
        const _isExtend = `${type}` === '1'
        const _multiExtendRecords = _multiRecordsBelongToOneExtendDosage(r)

        if (groupId || !(_isExtend && _multiExtendRecords)) {
          // 双波，普通延长量等等;即非"不是双波并且是被分割成多个的延长量"
          const data = _getBigDosageData(r, true) // "不是双波并且是被分割成多个的延长量",所以第二个参数可穿可不穿
          // 不是被分割的一个延长量(如果这个延长量被分割，也只能是这个这个延长量是双波大剂量里头的延长量)
          if (durationExpanded && _bigDosageShouldMerge(r, nextR)) { // _bigDosageShouldMerge返回是否是双波大剂量需要合并
            // 依次将后一个紧跟的延长量的开始时间"平移"
            _alreadyProcessedRecordsI.push(i + 1)
            const _nextOldCTime = nextR['dateTimeStr']
            const _nextOldDuration = nextR['delayTime']
            // 修改记录，不知道会不会触发vue的"响应式"
            // console.error(`大剂量记录被修改延长到至少${minWidthMinutes}分钟, [record, nextR]: `, [r, nextR]) // dev, mock
            nextR.data = nextR['totalBolus']
            nextR.check_time = dayjs(+dayjs(_nextOldCTime) + Math.abs(diff)).format('YYYY-MM-DD HH:mm:ss')
            nextR.true_check_time = _nextOldCTime

            if (_nextOldDuration) { // diff < 0 --> durationExpanded为true
              if (_nextOldDuration * 60 * 1000 - Math.abs(diff) < 0) {
                // 后面的持续时间，小于diff(也就是，第一个大剂量的根据minWidthMinutes进行填充的diff之后，需要从第二个大剂量里头挤压回来。否则会画超。尤其第二个大剂量打的过程中设备关机了——红线，这种时候会非常明显)
                nextR.delayTime = minWidthMinutes > 0 ? Math.max(_nextOldDuration, minWidthMinutes * 60 * 1000) : _nextOldDuration
                console.error(`后面的持续时间，小于diff.导致第二个大剂量也会画超。这种细度就暂时没办法了；尤其是在延长大剂量刚打了十来分钟，然后设备关机——红线，这样子的话就会暴露出来`)
                nextR.delayTime = minWidthMinutes > 0 ? ~~(1 / 3 * minWidthMinutes * 60 * 1000) : 1000
                nextR._diff = diff
              } else {
                // 从下一个duration里头,将第一个大剂量minWidthMinutes多画的offset，从第二个extended大剂量里头挤压回来
                nextR.delayTime = minWidthMinutes > 0 ? Math.max(_nextOldDuration, minWidthMinutes * 60 * 1000) : _nextOldDuration
                nextR._beforeDelayTime = nextR.delayTime
                nextR.delayTime += diff // 从第二个extended大剂量里头挤压回来,因为diff是负数，所以这里使用+=
              }
            }
            
            nextR.trueDuration = _nextOldDuration
          }

          const { groupId, index } = r
          rst.push({ ...r, data, check_time, true_check_time: check_time, duration, trueDuration: _d, type, groupId, extendId, index })
        } else {
          // 进入此分支_isExtend肯定是true, _multiExtendRecords也肯定是true
          if (!multiExtendRecords[extendId]) {
            multiExtendRecords[extendId] = []
          }
          multiExtendRecords[extendId].push(r)
        }
      }
    }
  })

  /* ++++++++++双波里头的被分割成多份的延长量,要加extendIdFirstOne标记++++++++++ */
  const _dualExtendIdIndexes = {} // 双波大剂量里头,是被分割的延长量(说明这延长量属于双波)，那么同一个extendId最靠前的index，后面需要添加extendIdFirstOne标记
  const _dualExtendIdLastOneIndexes = {} // 双波大剂量里头,是被分割的延长量(说明这延长量属于双波)，那么同一个extendId最靠后的index，后面需要此逻辑算出这一次延长量结束的时刻endPointTime
  rst.forEach((v, i) => {
    const { groupId, extendId } = v
    if (groupId) {
      // 双波
      if (extendId) {
        // 双波里头被分割成至少2条的延长量
        const old = _dualExtendIdIndexes[extendId]
        if (old === undefined) {
          _dualExtendIdIndexes[extendId] = i
        } else {          
          _dualExtendIdIndexes[extendId] = Math.min(old, i)
        }
        const oldLast = _dualExtendIdLastOneIndexes[extendId]
        if (oldLast === undefined) {
          _dualExtendIdLastOneIndexes[extendId] = i
        } else {
          _dualExtendIdLastOneIndexes[extendId] = Math.max(oldLast, i)
        }
      }
    }
  })
  // 打上extendIdFirstOne标记和totalDuration和duration4ui  
  Object.keys(_dualExtendIdIndexes).forEach(extendId => {
    const index = _dualExtendIdIndexes[extendId]
    if (+index >= 0) {
      const r = rst[index]
      r['totalDuration'] = r['totalExtendDelayTime']
      r['extendIdFirstOne'] = true // change,打标记
      const { delayTime, check_time: dateTimeStr } = r // 注意！注意！dateTimeStr其实使用的是我们处理过后的check_time字段。因为双波大剂量的时候，我们的check_time可能会被第一个立即大剂量挤压从而偏移
      const lastI = _dualExtendIdLastOneIndexes[extendId]
      let endPointTime = +dayjs(dateTimeStr) + +delayTime // 毫秒
      if (lastI >= 0) {
        const last = rst[lastI]
        endPointTime = +dayjs(last.dateTimeStr) + +last.delayTime // 毫秒
      } else {
        console.error(`[逻辑黑洞]lastI不存在`)
      }
      const duration4ui = dayjs(endPointTime) - dayjs(dateTimeStr) // 目前说，分割的延长量，不管其中插入了X条立即量，都要一口气画过去(即实际画出来的柱子的宽度，要加上X条立即量的宽度)
      Object.assign(r, {
        endPointTime,
        duration4ui
      })
    }
  })
  /* ++++++++++End of 双波里头的被分割成多份的延长量,要加extendIdFirstOne标记++++++++++ */

  // 整理多个被分割的extended大剂量(延长量);同一个延长量，可能中途会打多个立即大剂量，从而被分割成多段
  const extendeds = Object.keys(multiExtendRecords)
  error(`extendeds: `, extendeds)
  extendeds.forEach(extendId => {
    const arr = multiExtendRecords[extendId]
    // 不做durationExpanded
    let totalDuration = 0
    let totalBolus = 0 // 一个延长量被分割成多条记录，totalBolus指这一个延长量的总量
    let endPointTime = 0
    const rst2 = {}

    const al = arr.length
    arr.forEach((r, i) => {
      const isLastOne = i >= (al - 1)
      const { totalExtendDelayTime, totalExtendBolus, groupId, delayTime, dateTimeStr } = r // 只有第一条，才有totalExtendDelayTime和totalExtendBolus;但为了保险一点，我每一条都读

      if (groupId) {
        console.error(`[逻辑错误]虽然这个延长量有extendId，但是它也有groupId，所以应该老早合并到双波里头去.即进入本处的逻辑的记录一定是没有groupId. 为了避免渲染就不管了r: `, r)
      }

      if (totalExtendDelayTime) {
        totalDuration = totalExtendDelayTime
      }
      if (totalExtendBolus) {
        totalBolus = totalExtendBolus
      }

      if (isLastOne) {
        endPointTime = +dayjs(dateTimeStr) + +delayTime // 毫秒
      }
    })
    
    arr.forEach((r, i) => {
      // 这里的数据只能是"不是双波并且是被分割成多个的延长量"
      const data = _getBigDosageData(r, true) // 这一部分延长量实际执行的剂量值
      const check_time = r.dateTimeStr
      const _d = r.delayTime
      const _duration4Ui = dayjs(endPointTime) - dayjs(r.dateTimeStr) // 目前说，分割的延长量，不管其中插入了X条立即量，都要一口气画过去(即实际画出来的柱子的宽度，要加上X条立即量的宽度)
      const type = _getBigDosageType(r)
      
      const { index, totalExtendBolus } = r
      
      rst.push({ ...r, data, index, check_time, true_check_time: check_time, duration: _d, duration4ui: _duration4Ui, trueDuration: _d, type, extendId, totalDuration, endPointTime, totalExtendBolus: totalBolus, extendIdFirstOne: i === 0 })
    })
  })
  
  // console.error(`totalBoluses: `, (records.map((v, i) => {
  //   if (v.totalBolus > 0) {
  //     console.error(`i, ${i}`)
  //     console.error(`时间, ${v.dateTimeStr}`)
  //   }
  //   return v.totalBolus
  // })))

  if (!rst.length) {
    // derror(`大剂量数据为空: []`)
    return []
  }

  // 将大剂量记录进行合并成双波大剂量?

  const rstSorted = rst.sort((a, b) => dayjs(a.true_check_time) - dayjs(b.true_check_time))
  error(`_getPumpBigDosageFromRecords rstSorted: `, rstSorted)
  
  return rstSorted
}

export function _getMergedPumpBigDosageFromRecords(_bigDosages = [], minWidthMinutes) { // 主要是用来生成大剂量的分割线和大剂量的计数量
  // caution: 这里有个前提,我们是默认入参的records已经是有排序的，是按时间戳升序的

  // if (_bigDosages.length) {
  //   debugger
  // }
  // window.bbd = _bigDosages
  if (_bigDosages && _bigDosages.length === 0) {
    return []
  }
  let alreadyProcessBigDosageArray = false
  const records = _bigDosages.map(obj => qcopy(obj)) // 副本，不影响原来的list

  const rst = records.filter(r => {
    if (r) {
      if (r.duration !== undefined && r.data !== undefined && r.true_check_time !== undefined) {
        // 入参_bigDosages 已经是处理好的 大剂量数组(_getPumpBigDosageFromRecords函数的返回值{ data, check_time, duration, type })
        // 直接保留
        alreadyProcessBigDosageArray = true
        return true
      }
      const data = _getBigDosageData(r, true)
      const check_time = r.dateTimeStr
      const duration = r.delayTime // 微秒
      const type = r.dataType

      if (_legalBigDosageData(+data, r)) {
        return true
      }
    }
    return false
  })

  if (!alreadyProcessBigDosageArray) {
    console.error(`[逻辑有误]_getMergedPumpBigDosageFromRecords函数的第一个入参，一定要是_getPumpBigDosageFromRecords处理后得到的bigDosage的列表, records: `, records)
    return []
  }

  if (!rst.length) {
    // console.error(`大剂量数据为空,所以也无需合并: []`)
    return []
  }

  // 将大剂量记录进行合并?(只有一种情况: 打了立即量、然后马上接延长量;而不会说，打了延长量，然后马上接立即量。前文提到的'马上接'是指这个大剂量发生时间+持续的时间，正好等于下一个大剂量的发生时间)
  // caution: 这里有个前提,我们是默认入参的records已经是有排序的，是按时间戳升序的
  const merged = []

  // 合并相同的groupId
  const tmp = {} // key是一个个groupId
  const tmp2 = {} // key是一个个extendId;可能有些延长量本身属于一个groupId，所以merged时候groupId优先级比extendId高

  rst.forEach((v, i) => {
    const { groupId, extendId } = v

    if (!groupId && extendId) { // (非双波里头的被分割的延长量)一个延长量分成了多个records
      if (!tmp2[extendId]) {
        tmp2[extendId] = []
      }
      tmp2[extendId].push(v)
    } else if (groupId) {
      // 双波大剂量
      if (!tmp[groupId]) {
        tmp[groupId] = []
      }
      tmp[groupId].push(v)
    } else {
      merged.push(Object.assign({}, v))
    }
  })

  // 再把groupId的记录合并之后推入merged
  const keys = Object.keys(tmp)
  const keys2 = Object.keys(tmp2) // 延长大剂量(只包含那些一个延长大剂量被分割成多个records的)
  keys.forEach((groupId) => {
    // 双波大剂量
    const arr = tmp[groupId] || []
    const l = arr.length

    if (l === 0) {
      return
    }
    
    const rst = Object.assign({}, arr[0], { totalRecordsNum: l })
    if (!rst['trueDuration']) {
      console.error(`[逻辑有误]_getMergedPumpBigDosageFromRecords函数的第一个入参，一定要是_getPumpBigDosageFromRecords处理后得到的bigDosage的列表, 否则就没有trueDuration字段;为了逻辑不崩，设置成0. record: `, rst)
      rst[`trueDuration`] = 0
    }
    let duration = +rst['trueDuration'] || 0
    let data = 0

    const indexesArr = []
    // if ([875, 874, 873, 872, 871, 870].includes(+rst.index)) {
    //   debugger
    // }
    for (let i = 0; i < l; i++) { // 将arr数组里的记录全部合并
      const cur = arr[i]
      const type = _getBigDosageType(cur)
      const _d = _getBigDosageData(cur, false) // 第二个参数一定要传false。这样子才会延长量有时候取totalBolus，有时候取totalExtendBolus
      data += (+_d) 

      indexesArr.push(cur['index'])
      const next = arr[i + 1]
      if (next) {
        let d = next['trueDuration']
        if (!d) {
          console.error(`[逻辑有误]_getMergedPumpBigDosageFromRecords函数的第一个入参，一定要是_getPumpBigDosageFromRecords处理后得到的bigDosage的列表, 否则就没有trueDuration字段;为了逻辑不崩，改成使用duration字段. record: `, next)
          d = next['duration']
        }
        
        duration += (+d)

        const k = i + 2
        rst[`data${k}`] = next['data']
        rst[`check_time${k}`] = next['check_time']
        rst[`true_check_time${k}`] = next[`true_check_time`]
        rst[`true_duration${k}`] = next[`trueDuration`]
        rst[`duration${k}`] = next[`duration`]
      }
    }

    rst['indexes'] = indexesArr.join(',')
    
    /* ++++++++++判断出哪个index记录是这个双波的第一条记录++++++++++ */
    const _indexesMax = indexesArr.reduce((a, b) => {
      return Math.max(a, b)
    })
    const _indexesMin = indexesArr.reduce((a, b) => {
      return Math.min(a, b)
    })
    const _loopGapBuffer = 10
    const _indexLooped = Math.abs(_indexesMax - _indexesMin) > _loopGapBuffer // index套圈了(假设最多200条，套圈就是上一条是199，下一条index变成0)
    let _dualFirstIndex = -1
    let _findInThisArr = indexesArr
    if (_indexLooped) {
      // 最小值从未套圈的数组里头取
      _findInThisArr = indexesArr.filter(v => Math.abs(v - _indexesMax) - _loopGapBuffer <= 0)
    }    
    _dualFirstIndex = _findInThisArr.reduce((a, b) => {
      return Math.min(a, b)
    })
    if (_dualFirstIndex >= 0) {
      rst[`dualFirstRecord`] = +_dualFirstIndex === +rst['index']
    }
    /* ++++++++++End of 判断出哪个index记录是这个双波的第一条记录++++++++++ */
    
    rst[`trueDuration`] = rst[`duration`] = duration
    rst[`dualTotalBolus`] = data
    rst[`dataType`] = rst[`type`] = '2' // ablian自定义的type，意味其是双波
    // 推入merged
    merged.push(rst)
  })

  // 延长大剂量(只包含那些一个延长大剂量被分割成多个records的),开始合并
  keys2.forEach((extendId) => {
    const arr = tmp2[extendId] || []
    const l = arr.length
    if (l === 0) {
      return
    }
    const rst = Object.assign({}, arr[0], { totalRecordsNum: l })
    if (!rst['trueDuration']) {
      console.error(`[逻辑有误]keys2,_getMergedPumpBigDosageFromRecords函数的第一个入参，一定要是_getPumpBigDosageFromRecords处理后得到的bigDosage的列表, 否则就没有trueDuration字段;为了逻辑不崩，设置成0. record: `, rst)
      rst[`trueDuration`] = 0
    }

    const indexesArr = []
    for (let i = 0; i < l; i++) { // 将arr数组里的记录全部合并
      const cur = arr[i]
      indexesArr.push(cur['index'])
      // if (!cur['index']) {
      //   debugger
      // }
      const next = arr[i + 1]
      if (next) {
        let d = next['trueDuration']
        if (!d) {
          console.error(`[逻辑有误]keys2,_getMergedPumpBigDosageFromRecords函数的第一个入参，一定要是_getPumpBigDosageFromRecords处理后得到的bigDosage的列表, 否则就没有trueDuration字段;为了逻辑不崩，改成使用duration字段. record: `, next)
          d = next['duration']
        }
        
        const k = i + 2
        rst[`data${k}`] = next['data']
        rst[`check_time${k}`] = next['check_time']
        rst[`true_check_time${k}`] = next[`true_check_time`]
        rst[`true_duration${k}`] = next[`trueDuration`]
        rst[`duration${k}`] = next[`duration`]
      }
    }

    rst['indexes'] = indexesArr.join(',')
    
    // 推入merged
    merged.push(rst)
  })
  
  // tbc, merged根据时间排序一下
  const t = merged.sort((f, s) => dayjs(f.true_check_time) - dayjs(s.true_check_time)) // { data, check_time, duration, type, true_check_time } ; 如果type是数组，意味着是合并的记录
  console.log(`_bigDosages: `, _bigDosages)
  console.log(`merged: `, t)
  return t

  // rst.forEach((v, i) => {
  //   if (v && v._hasBeedMerged) {
  //     return true
  //   }
    
  //   const orin = v
  //   const after = rst[i + 1] || {}
  //   let _shouldMerge = false

  //   if (alreadyProcessBigDosageArray) {
  //     _shouldMerge = _bigDosageShouldMerge({
  //       ...orin,
  //       dataType: orin.type,
  //       delayTime: orin.duration,
  //       dateTimeStr: orin.check_time,
  //       totalBolus: orin.data
  //     }, {
  //       ...after,
  //       dataType: after.type,
  //       delayTime: after.duration,
  //       dateTimeStr: after.check_time,
  //       totalBolus: after.data
  //     })
  //   } else {
  //     _shouldMerge = _bigDosageShouldMerge(orin, after)
  //   }

  //   if (_shouldMerge) {
  //     // 合并
  //     if (alreadyProcessBigDosageArray) {
  //       after._hasBeedMerged = true
  //       const rst = Object.assign({}, v, {
  //         duration: v.duration + after.duration,
  //         data2: after.data,
  //         check_time2: after.check_time
  //       })
  //       if (+rst.data === 0) {
  //         // 第一个大剂量(normal)为0,那么认为这个合并的大剂量依然为'extended'，而不是'Dual-wave bolus(双波)'
  //         rst.type = after.type // 应该就是'extended'
  //         if (!_isExtendDosage(after.type)) {
  //           console.error(`[大剂量数据有误], 合并的大剂量，第一个大剂量是: ${JSON.stringify(v)}, 第二个大剂量却不是extended大剂量,这是不对的, 第二个大剂量数据: ${JSON.stringify(after)}`)
  //         }
  //       } else {
  //         // 这种情况下，应该是'Dual-wave bolus(双波)'
  //         // 由于服务端接口没有定义双波大剂量的type, 所以我这边直接定义成2
  //         rst.dataType = rst.type = '2' // ablian自定义的type，意味其是双波
  //       }
  //       merged.push(rst)
  //     } else {
  //       const data = v.totalBolus
  //       const check_time = v.dateTimeStr
  //       const duration = +v.delayTime + +after.delayTime // 微秒
  //       const type = [v.dataType, after.dataType]
        
  //       after._hasBeedMerged = true
        
  //       const rst = {
  //         ...{ data, check_time, duration, type },
  //         data2: after.totalBolus,
  //         check_time2: after.dateTimeStr
  //       }

  //       if (+data === 0) {
  //         // 第一个大剂量(normal)为0,那么认为这个合并的大剂量依然为'extended'，而不是'Dual-wave bolus(双波)'
  //         rst.type = after.dataType // 应该就是'extended'
  //         if (!_isExtendDosage(after.dataType)) {
  //           console.error(`[大剂量数据有误], 合并的大剂量，第一个大剂量是: ${JSON.stringify(v)}, 第二个大剂量却不是extended大剂量,这是不对的, 第二个大剂量数据: ${JSON.stringify(after)}`)
  //         }
  //       } else {
  //         // 这种情况下，应该是'Dual-wave bolus(双波)'
  //         // 由于服务端接口没有定义双波大剂量的type, 所以我这边直接定义成2
  //         rst.type = '2' // ablian自定义的type，意味其是双波
  //       }
        
  //       merged.push(rst)
  //     }
  //   } else { // v不合并,所以v单独直接推入merged数组
  //     if (alreadyProcessBigDosageArray) {
  //       merged.push(v)
  //     } else {
  //       const data = v.totalBolus
  //       const check_time = v.dateTimeStr
  //       const duration = v.delayTime // 微秒
  //       const type = v.dataType
        
  //       merged.push({ data, check_time, duration, type }) 
  //     }
  //   }
  // })
  
  // return merged // { data, check_time, duration, type } ; 如果type是数组，意味着是合并的记录
}
function _isImediateDosage(type) { // 立即大剂量
  return `${type}` === '0'
}

function _isExtendDosage(type) { // 延长大剂量
  return `${type}` === '1'
}
function _isDualDosage(type) { // 双波大剂量，是我们自己定义的，并且我们自己会定义一个type为2
  return `${type}` === '2'
}

// function _bigDosageShouldMerge(a1 = {}, a2 = {}) {
//   let merge = false  
//   if (a1 && _isImediateDosage(a1.dataType) && a2 && _isExtendDosage(a2.dataType)) {
//     const a1s = +dayjs(a1.dateTimeStr)
//     const a1d = a1.delayTime
//     const a2s = +dayjs(a2.dateTimeStr)
//     const buffer = 1 * 1000 // 上下浮动1s;理论上是直接相等的，即buffer应该为0

//     const gap = Math.abs(a2s - a1s)

//     if (gap - (buffer + a1d) <= 0) {
//       merge = true
//     } else {
//       console.error(`虽然第一条是立即量，第二条是延长量，但是这两条不是'马上接着的'，所以不合并这两条记录`)
//     }
//   }

//   return merge
// }

function _bigDosageShouldMerge(a1 = {}, a2 = {}) { // 双波大剂量，需要合并
  return a1 && a2 && a1.groupId && a2.groupId && `${a1.groupId}` === `${a2.groupId}`
}
function _multiRecordsBelongToOneExtendDosage(a1) { // 延长大剂量: 会被分割成多个;当然，大部分情况是一个
  return a1 && a1.extendId
}

export function SVG(tag) {
  return document.createElementNS('http://www.w3.org/2000/svg', tag)
}

export function _appendRoundedCorners($g, extra = {}) { // svg圆弧: https://www.cnblogs.com/igin/p/16919891.html
  const { id, w, durationW = 0, isLeft = true, borderColor, isTop = true, offsetX = 0, offsetY = 0 } = extra // 默认左上角(isLeft),默认是上部的corner
  const $newPath = $(SVG('path')) // svg元素没有innterHTML，所以通过这种方式，从而使jquery能成功添加path元素 // https://chubao4ever.github.io/tech/2015/07/16/jquerys-append-not-working-with-svg-element.html
  let leftCornerD = `M-1 -1l${w} 0a${w} ${w} 0 0 0 -${w} ${w}Z`
  let leftCornerBorder = `M${w} 0a${w} ${w} 0 0 0 -${w} ${w}`
  // const rightCornerD = `M${duration * oneHourW + 1} -1l-${w} 0a${w} ${w} 0 0 1 ${w} ${w}Z`
  let rightCornerD = `M${durationW + 1} -1l-${w} 0a${w} ${w} 0 0 1 ${w} ${w}Z`
  let rightCornerBorder = `M${durationW + 1 - w} 0a${w} ${w} 0 0 1 ${w} ${w}`

  const zindex = 3

  if (!isTop) {
    const pad = 2
    const w2 = w + pad
    leftCornerD = `M${0} ${0}l${w2} ${pad}a${w2} ${w2} 0 0 1 ${-w2} ${-w2}Z`
    leftCornerBorder = `M${w2} ${pad}a${w2} ${w2} 0 0 1 ${-w2} ${-w2}`
    // leftCornerBorder = `M${w} 0a${w} ${w} 0 0 1 ${-w} ${-w}`
    rightCornerD = `M${durationW + pad} ${pad}l${-w2 - pad} ${0}a${w2} ${w2} 0 0 0 ${w2 + pad} ${0 - pad - w2}Z`
    rightCornerBorder = `M${durationW - w2} ${pad}a${w2} ${w2} 0 0 0 ${w2 + pad} ${0 - pad - w2}`
    // leftCornerD = `M-1 -1l${w} 0a${w} ${w} 0 0 0 -${w} ${w}Z`
    // leftCornerBorder = `M${w} 0a${w} ${w} 0 0 0 -${w} ${w}`
  }

  $newPath.attr('d', (isLeft ? leftCornerD : rightCornerD))
  $newPath.attr('fill', 'white')
  // $newPath.attr('fill', 'red')
  $newPath.attr('z-index', zindex)
  $newPath.attr('id', id)
  // $newPath.attr('transform', `translate(${start * oneHourW + mealLabelOffsetX}, ${mealLabelOffsetY})`)
  $newPath.attr('transform', `translate(${offsetX}, ${offsetY})`)
  $newPath.appendTo($g)

  if (borderColor) {
    const $border = $(SVG('path'))
    $border.attr('z-index', zindex)
    $border.attr('d', (isLeft ? leftCornerBorder : rightCornerBorder))
    $border.attr('fill', 'none')
    $border.attr('id', `${id}_border`)
    $border.attr('transform', `translate(${offsetX}, ${offsetY})`)
    $border.attr('stroke', borderColor)
    // $border.attr('stroke', 'blue')
    $border.appendTo($g)
  }
}

export function _sortCgmRecordListByTimeAsc(cgmRecordList = [], isAsc = true) {
  return cgmRecordList.sort((first, second) => {
    return isAsc ? (dayjs(first.deviceTimeStr) - dayjs(second.deviceTimeStr)) : (dayjs(second.deviceTimeStr) - dayjs(first.deviceTimeStr))
  })
}

export function _bgSortOriginDataByDayList(values = []) {
  const sortedOriginDataByDayList = []

  // 将每一天的数据归类一下
  // step1, 将所有数据归类到24个小时间隔 0-1, 1-2, ...
  values.forEach((oneDay = {}) => {
    const rangeDatas = Array.from({ length: 24 }) // 一天24小时
    
    const { bloodGlucoseRecord: oneDayList, date } = oneDay
    
    oneDayList.forEach(v => {
      const { testTimeStr } = v
      if (!testTimeStr) {
        error(`[数据有误]无法获取testTimeStr, 直接过滤掉数据 v: ${JSON.stringify(v)}`)
        return 
      }
      const hour = +(dayjs(testTimeStr).format(`H`))
      
      const range = rangeDatas[hour]
      
      if (!Array.isArray(range)) {
        rangeDatas[hour] = []
      }
      
      rangeDatas[hour].push(v)
    })
    
    // step2, 将每一天里头的每一个小时区间内的的记录按照血糖值进行排序，降序(即，index 0的值最大)
    rangeDatas.forEach((oneHourGapAllData) => {
      if (Array.isArray(oneHourGapAllData)) {
        oneHourGapAllData.sort((first, second) => { // 返回>0,那么first要排到second后面去,即升序;
          if (!first || Number.isNaN(first.bloodGlucose)) {
            // 不合法的first
            error(`【接口数据有误】将血糖数据按照每一天的小时区间进行血糖值排序时，发现数据没有合法的bloodGlucose.不调动其位置. v: ${first ? JSON.stringify(first) : first}`)
            return 0
          }
          if (!second || Number.isNaN(second.bloodGlucose)) {
            // 不合法的second
            error(`【接口数据有误】将血糖数据按照每一天的小时区间进行血糖值排序时，发现数据没有合法的bloodGlucose.不调动其位置. v: ${second ? JSON.stringify(second) : second}`)
            return 0
          }
          
          return second.bloodGlucose - first.bloodGlucose // 降序。即index 0是血糖值最大的
        }) 
      }
    })
    
    sortedOriginDataByDayList.push({
      list: rangeDatas,
      date
    }) // rangeDatas的每一个小时区间里头的数据，已经排序过了。是降序的(index 0的血糖值最大)
  })
  
  return sortedOriginDataByDayList
}

export const universalFontFamily = `HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif`

export const canvasRatio = 2 // 使用canvas渲染会有点糊，所以需要设置ratio: canvasRatio;这个ratio会影响斑马图的绘制
